import React from "react";

const SearchBar = ({ value, onChange, onSubmit, loading }) => {
  return (
    <form onSubmit={onSubmit} className="search-form" role="search">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search for a city..."
        className="search-input"
        aria-label="City name"
        autoComplete="off"
        spellCheck="false"
      />
      <button
        type="submit"
        className="search-button"
        disabled={loading}
        aria-label="Search weather"
      >
        {loading ? (
          <span className="spinner" aria-hidden="true" />
        ) : (
          "Search"
        )}
      </button>
    </form>
  );
};

export default SearchBar;
